import { Service } from '@angular/core';
import { Subject } from 'rxjs';

@Service()
export class WindowResizeService {

  resized$ = new Subject<void>();

  constructor() { }
}
